import { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@/components/modals/modal/modal.component'
import Button from '@/components/buttons/button/button.component'

export interface InfoChanged {
  state: boolean
  message: string
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  infoChanged: InfoChanged
  disableButton?: boolean
  loading?: boolean
  onDiscard?: (discard: boolean) => any
  onSave?: () => any
}

export default ({ infoChanged, disableButton, loading, onDiscard, onSave }: Props) => {
  const [t] = useTranslation('modalUnsaveData')
  const [open, setOpen] = useState(false)
  const [infoChangedState, setInfoChangedState] = useState({
    state: false,
    message: '',
  })

  useEffect(() => {
    if (infoChangedState.state !== infoChanged.state || infoChangedState.message !== infoChanged.message) {
      setInfoChangedState(infoChanged)
    }
  }, [infoChangedState, infoChanged])

  useEffect(() => {
    const element = document.querySelector('div.default-layout')

    const validateEvent = async (event) => {
      const verify: any = async () => {
        const list = []
        for (const aux in event?.path) {
          if (typeof event?.path?.[aux]?.className === 'string') {
            list.push(event?.path?.[aux]?.className)
          }
        }
        if (list.find((item) => item.includes('avatar') || item.includes('cancel-button-navigation-cross'))) {
          return true
        }
        return list
      }

      if (event?.target?.type === 'submit' || event?.target?.id === 'save-button-navigation') {
        return false
      }
      if (Array.isArray(await verify()) && (await verify()).find((item) => item.includes('change-document-modal'))) {
        return false
      }
      return (
        event?.target?.localName === 'a' ||
        event?.target?.parentElement?.localName === 'a' ||
        event?.target?.localName === 'button' ||
        event?.target?.parentElement?.localName === 'button' ||
        (await verify()) === true
      )
    }

    async function showModal(event) {
      if (await validateEvent(event)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        setOpen(true)
        document.addEventListener(
          'click',
          (e) => {
            if (e.composedPath().includes(element)) {
              element.removeEventListener('click', showModal)
            }
          },
          { capture: true }
        )
      }
    }

    window.onbeforeunload = function () {
      return infoChangedState.state ? '' : null
    }

    if (infoChangedState.state) {
      element.addEventListener('click', showModal)
    } else {
      setOpen(false)
    }
    return () => {
      element.removeEventListener('click', showModal)
    }
  }, [infoChangedState])

  const closeModal = useCallback(() => {
    if (onDiscard && typeof onDiscard === 'function') {
      onDiscard(true)
    }
    setOpen(false)
  }, [onDiscard])

  const saveData = useCallback(() => {
    if (onSave && typeof onSave === 'function') {
      onSave()
    }
  }, [onSave])

  const Footer = () => (
    <div className="actions col-24 display-flex justify-content-space-between">
      <Button color="transparent" textColor="var(--text_color)" borderStyle="none" onClick={() => closeModal()} disabled={loading}>
        {t('discard')}
      </Button>
      <Button onClick={() => saveData()} loading={loading} disabled={disableButton}>
        {t('save')}
      </Button>
    </div>
  )

  return (
    <Modal open={open} header={<h5 className="mb-0">{t('title')}</h5>} footer={<Footer />} modalSize="sm" buttonClose={false}>
      <p style={{ padding: '2rem 0', fontWeight: 500 }}>{infoChangedState.message}</p>
    </Modal>
  )
}
